import { Fragment, type SyntheticEvent } from "react";

const URL_PATTERN = /(https?:\/\/[^\s<>"]+[^\s<>".,;:!?)\]}'])/g;

const linkClass = "break-all text-info underline underline-offset-2";

/** Stops a link inside a card or editable surface from also firing the
 * surrounding gesture (a card drag, or switching a field into edit mode). */
function stopGesture(event: SyntheticEvent) {
  event.stopPropagation();
}

/** Renders plain text with bare http(s) URLs turned into external links. */
export function LinkifiedText({ text }: { text: string }) {
  const parts = text.split(URL_PATTERN);
  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
            onPointerDown={stopGesture}
            onClick={stopGesture}
          >
            {part}
          </a>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </>
  );
}
